import { ReactNode, useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import { tablet, mobile } from '../../../utils/responsive-helper'
import ShopCard from '../../../components/ShopCard'
import { useGetShopBrandProductList } from '../../../services/shop/shop-query'
import Button from '../../../components/common/Button'
import Loading from '../../../components/common/Loading'
import { brandReward } from '../../../constant/path'
import { useTranslation } from 'react-i18next'

const Layout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 267px);
  grid-gap: 24px;

  ${tablet} {
    grid-template-columns: repeat(auto-fill, 343px);
    grid-gap: 24px;
    justify-content: center;
    .shop-card {
      width: 343px;
      height: 421px;
    }

    .shop-card-img {
      width: 343px;
      height: 243px;
    }
  }

  ${mobile} {
    grid-template-columns: unset;
    grid-gap: unset;
    .shop-card {
      width: 100%;
      height: 421px;
    }

    .shop-card-img {
      width: 100%;
      height: 243px;
    }
  }
`

const LoadingStyle = styled.div`
  display: flex;
  justify-content: center;
`

type CategoryGroupProp = {
  brandId: number
  brandName: string
  children?: ReactNode
}

const CategoryGroup = (props: CategoryGroupProp) => {
  const { brandId, brandName } = props
  const { data, fetchNextPage, hasNextPage, isLoading, isFetching } = useGetShopBrandProductList(
    brandId,
  )

  const { t } = useTranslation()

  const getPath = useCallback(
    (productId: number) => {
      return brandReward({
        routeParam: { rewardId: productId, brandId },
        queryParam: { title: brandName },
      })
    },
    [brandId, brandName],
  )

  const onClickLoading = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  const products = useMemo(() => {
    return data?.pages.map(({ content: contents }) => {
      return contents.map((content: any, index: number) => {
        const { id, specialCoin, title, thumbnailImage, remain } = content
        return (
          <ShopCard
            key={index}
            image={thumbnailImage}
            title={title}
            point={specialCoin}
            remain={remain}
            path={getPath(id)}
          />
        )
      })
    })
  }, [data?.pages, getPath])

  return (
    <Loading style={{ height: 100 }} loading={isLoading}>
      <Layout>{products}</Layout>
      <LoadingStyle>
        <Loading loading={!isLoading && isFetching}>
          <Button disabled={!hasNextPage} onClick={onClickLoading}>
            {t('shop.seeMore')}
          </Button>
        </Loading>
      </LoadingStyle>
    </Loading>
  )
}

export default CategoryGroup
